<form class="self-stretch" (submit.prevent)="onSubmit()">
  <ui-simple-dialog-layout (clickCancel)="clickCancel.emit()">
    <!-- title -->
    <ng-container slot="title">
      {{ 'cockpit.energyInterfaces.createDialog.title' | transloco }}
    </ng-container>
    <!-- content -->
    <app-energy-interface-create-form
      [locationId]="locationId()"
      [utilityType]="utilityType()"
      [showUtilityTypeInput]="showUtilityTypeInput()"
      [energyInterfaceData]="energyInterfaceData()"
      [showFormValidityErrors]="showFormValidityErrors()"
    />
    <!-- footer -->
    <ui-button
      slot="footer"
      mode="outlined"
      expand="full"
      type="button"
      (click)="clickCancel.emit()"
      class="block"
    >
      {{ 'cockpit.energyInterfaces.createDialog.cancelButton' | transloco }}
    </ui-button>
    <ui-button
      slot="footer"
      expand="full"
      class="block"
      type="submit"
      [loading]="energyInterfacesStore.isCreateLoading() || isEditLoading()"
    >
      @if (energyInterfaceID()) {
        {{ 'cockpit.energyInterfaces.createDialog.saveButton' | transloco }}
      } @else {
        {{ 'cockpit.energyInterfaces.createDialog.submitButton' | transloco }}
      }
    </ui-button>

    @if (showFormValidityErrors() && energyInterfaceForm()?.form()?.invalid()) {
      <span slot="error">
        {{ 'cockpit.energyInterfaces.createDialog.formInvalid' | transloco }}
      </span>
    } @else if (energyInterfacesStore.createError()) {
      <span slot="error">
        {{ 'cockpit.energyInterfaces.createDialog.createError' | transloco }}
      </span>
    } @else if (editError()) {
      <span slot="error">
        {{ 'cockpit.energyInterfaces.createDialog.saveError' | transloco }}
      </span>
    }
  </ui-simple-dialog-layout>
</form>
